import { createApp } from 'vue';

import App from './App.vue';

import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
polyfillCountryFlagEmojis();

import { registerPlugins } from '@/plugins';
import { registerFilters } from '@/plugins/filters';

const app = createApp(App);

const debugMode = localStorage.getItem('debugMode');
const isLocalhost =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

if (debugMode !== 'true' && !isLocalhost) {
    app.config.devtools = false;
    app.config.debug = false;
    app.config.silent = true;
    console.log = function () {};
    console.warn = function () {};
    console.error = function () {};
    console.info = function () {};
    console.debug = function () {};
}

// console.log('NODE_ENV:', process);

registerPlugins(app);
registerFilters(app);

app.mount('#app');
